"use client";

import { usePathname } from "next/navigation";
import { isPublicUrl } from "src/config/publicUrls";
import { Sidebar } from "./projects/Sidebar";

/**
 * Chooses the app chrome — sidebar or bare full width — from the LIVE pathname.
 *
 * This cannot be decided in the root layout. That layout renders once per
 * document load and Next.js reuses it across every client-side navigation, so
 * anything it computes from the request path is frozen for the life of the
 * document: a session that starts on `/logout` and soft-navigates back into the
 * app would keep the bare public chrome, with no sidebar and no content offset,
 * until a full reload. `usePathname()` re-renders on navigation, so the chrome
 * tracks the route the way the profile query does.
 */
export function AppShell({
  children,
  smallLogo,
  largeLogo,
}: Readonly<{
  children: React.ReactNode;
  smallLogo: React.ReactNode;
  largeLogo: React.ReactNode;
}>) {
  const pathname = usePathname();

  if (isPublicUrl(pathname ?? "")) {
    return <div className="h-screen">{children}</div>;
  }

  return (
    <div>
      <Sidebar smallLogo={smallLogo} largeLogo={largeLogo} />
      <div className="ml-16 h-screen">{children}</div>
    </div>
  );
}
